import React, { useState, useEffect, Fragment } from "react";
import "./styles.scss";
import Layout from "../../components/Layout/Layout";
import CardItem from "../../components/CardItem/CardItem";
import { Link, useHistory } from "react-router-dom";
import ViewMore from "../../components/ViewMore/ViewMore";
import {
  NotificationManager,
  NotificationContainer,
} from "react-notifications";

import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  fetchViewFavorite,
  fetchFavoriteRemove,
} from "../../redux/actions/products";


const ProductSaved = (props) => {
  const [activeTab, setActiveTab] = useState(true);
  const [favorites, setFavorites] = useState([]);
  const [stores, setStores] = useState([]);
  const history = useHistory();
  const toggle = () => setActiveTab(!activeTab);
  const btn_class = activeTab ? "active-btn" : "saved-btn";
  const btn_class2 = activeTab ? "saved-btn" : "active-btn";
  const [pageCount, setPage] = useState(6);

  function viewMore() {
   activeTab && props.fetchViewFavorite(pageCount);
    setPage(pageCount + 6);
  }

  function removeFav(id) {
    props.fetchFavoriteRemove(id); 
  }

  useEffect(() => {
    props.fetchViewFavorite();
  }, []);

  useEffect(() => {
    if (props.favorites.favorites.data) {
      //NotificationManager.success(props.favorites.favorites.message);
      setFavorites(props.favorites.favorites.data.favourites);
    }
  }, [props.favorites.favorites]);

  return (
    <Layout>
      <NotificationContainer />
      <section className="saved-section">
        <div className="bread-crumbs">
          <Link to="/">Home</Link> <i class="fa fa-caret-right pl-2 pr-2"></i>
          <Link to="/product-category">Saved</Link>
        </div>
        <div className="p-3 d-flex justify-content-center">
          <p className={btn_class} onClick={toggle}>
            Products
          </p>
          {/* <p className={btn_class2} onClick={toggle}>
            Stores
          </p> */}
        </div>

        <div className="row saved-section-items">
          {activeTab && (
            <Fragment>
              {(favorites || []).map((item, i) => {
                return (
                  <div className="">
                    <CardItem
                      like
                      photo={item.product.images[0]}
                      item={item.product.product_name}
                      price={item.product.price}
                      desc={item.product.description}
                      navigate={() =>
                        history.push(`/product/${item.product_id}`)
                      }
                      saved={() => removeFav(item.product_id)}
                    />
                  </div>
                );
              })}
            </Fragment>
          )}
  
        </div>

        <ViewMore viewHandler={viewMore} />
      </section>
    
    </Layout>
  );
};

//export default ProductSaved;
ProductSaved.propTypes = {
  favorites: PropTypes.object.isRequired,
  fetchAddressDelete: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => ({
  favorites: state.favorites,
});

const pageActions = {
  fetchViewFavorite,
  fetchFavoriteRemove
};

export default connect(mapStateToProps, pageActions)(ProductSaved);
